import { loginApi } from '../../setup/setupApi';
import { ChecklistOptions } from './types';

export const getChecklistOptions = (projectId: string): Promise<ChecklistOptions> =>
  loginApi.get(`/projects/${projectId}/checklist`).then((res) => res.data);

export const enableCheckOption = (projectId: string, option: string): Promise<boolean> =>
  loginApi.put(`/projects/${projectId}/checklist/${option}/check`).then((res) => res.data);
